<template>
  <swiper 
  :slides-per-view="1" 
  autoplay
  :speed="data.params.interval"
  :pagination="{ clickable: true }"
    :scrollbar="{ draggable: true }"
    @swiper="onSwiper"
    @slideChange="onSlideChange">
    <swiper-slide v-for="(item,index) in data.data" :key="index">
      <img :src="item.imgUrl?item.imgUrl:require('@/assets/images/normal.png')" alt="">
    </swiper-slide>
  </swiper>
</template>
<script>
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
// Import Swiper styles
import "swiper/swiper.less";
import "swiper/components/navigation/navigation.less";
import "swiper/components/pagination/pagination.less";
import "swiper/components/scrollbar/scrollbar.less";
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);
export default {
  props: { data: Object },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup(props) {
    const onSwiper = (swiper) => {
    };
    const onSlideChange = () => {
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
};
</script>